export const environment = {
  production: true,
  stripePublicKey : 'pk_live_51Rb0u6GVHslHROTjw6e1VbGjAbvN1Sqol9gQnkwDd6R15365sQtzYDrjAp8IgWUVfj1L9hmTv6sQBuQ6t6JZDw7000AdAMU7TQ',
  apiBaseUrl: 'https://www.jangukit.com/',
  redirectUrl: '?redirect_uri=https://www.jangukit.com/callback/'

};
